import { render, staticRenderFns } from "./IFlag.vue?vue&type=template&id=445b45d7&"
import script from "./IFlag.vue?vue&type=script&lang=ts&"
export * from "./IFlag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports